import React, { useState, useCallback } from "react";
import { useQuery, gql } from "@apollo/client";
import Sidebar from "../Sidebar";
import Layout from "../Layout";
import Loader from "../../Loader";
import FilterBar from "../AdminDashboard/FilterBar";
import EmployeeFeedbackDashboard from "../UserManagement/EmployeeDashboard/EmployeeFeedbackDashboard";
import dayjs from "dayjs";

const GET_EMPLOYEES = gql`
  query getEmployeeList($data: EmployeeFilterInput) {
    getEmployeelist(data: $data) {
      employee {
        id
        fullName
      }
    }
  }
`;

const FeedbackDashboard = () => {
  const [filters, setFilters] = useState(() => {
    const today = dayjs().format("YYYY-MM-DD");
    const sevenDaysAgo = dayjs().subtract(6, "day").format("YYYY-MM-DD");

    return {
      startDate: sevenDaysAgo,
      endDate: today,
      employeeIds: [],
    };
  });

  const { data: empData } = useQuery(GET_EMPLOYEES, {
    variables: { data: { bookableOrEmployed: true } },
  });

  const employees = empData?.getEmployeelist?.employee || [];

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
  }, []);

  return (
    <div className="min-h-screen flex">
      <Sidebar />
      <Layout>
        <div className="relative flex flex-col space-y-6 p-6 overflow-y-auto no-scrollbar">
          <div className="flex flex-col gap-2">
            <h2 className="text-2xl font-bold text-gray-900">
              Feedback Analytics
            </h2>
            <p className="text-gray-600 text-sm">
              Overall feedback and ratings distribution across employees.
            </p>
          </div>

          <FilterBar
            employees={employees}
            onFilterChange={handleFilterChange}
            showFrequencyFilter={false}
          />

          <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
            <EmployeeFeedbackDashboard
              employeeId={
                filters.employeeIds.length === 1 ? filters.employeeIds[0] : null
              }
              allEmployeeIds={
                filters.employeeIds.length > 1 ? filters.employeeIds : null
              }
              startDate={filters.startDate}
              endDate={filters.endDate}
              isOverall={true}
            />
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default FeedbackDashboard;
